<template lang="html">
  <!-- Sidebar -->
  <div class="border-right" id="sidebar-wrapper">
    <div class="header-sidebar" slot="header">
      <img src="../../../assets/UNODC-logo-full.png" alt="" width="200" />
    </div>
    <div class="list-group list-group-flush mb-3">
      <router-link
        to="/dashboard/Admin/adminDashboardView"
        class="list-group-item list-group-item-action"
      >
        <i class="material-icons">home</i> Dashboard
      </router-link>

      <router-link
        to="/dashboard/Admin/adminDashboard"
        class="list-group-item list-group-item-action"
      >
        <i class="material-icons">folder</i> Explore Trainings
      </router-link>
      <div>
        <div
          slot="header"
          class="list-group-item list-group-item-action"
          id="mybutton"
        >
          <i class="material-icons pr-1">brightness_low</i
          ><b>Training Management</b>
        </div>
        <ul>
          <router-link
            to="/dashboard/admin/trainingWizard"
            class="list-group-item list-group-item-action"
            style="color:#8e8e8e"
          >
            <i class="material-icons">remove</i> Training Wizard
          </router-link>
          <router-link
            to="/dashboard/admin/essentialSystem"
            class="list-group-item list-group-item-action"
            style="color:#8e8e8e"
          >
            <i class="material-icons">remove</i> Essential Data
          </router-link>
          <router-link
            to="/dashboard/Admin/QuestionBankAdmin"
            class="list-group-item list-group-item-action"
            style="color:#8e8e8e"
          >
            <i class="material-icons">remove</i> Create Question Bank
          </router-link>
          <router-link
            to="/dashboard/Admin/KnowledgeBaseArchives"
            class="list-group-item list-group-item-action"
            style="color:#8e8e8e"
          >
            <i class="material-icons">remove</i> Knowledge Base
          </router-link>
          <router-link
            to="/dashboard/Admin/questionbankarchives"
            class="list-group-item list-group-item-action"
            style="color:#8e8e8e"
          >
            <i class="material-icons">remove</i> Question Bank
          </router-link>

          <router-link
            to="/dashboard/Admin/subProgram"
            class="list-group-item list-group-item-action"
            style="color:#8e8e8e"
          >
            <i class="material-icons">remove</i> Subprogram
          </router-link>

          <router-link
            to="/dashboard/Admin/project"
            class="list-group-item list-group-item-action"
            style="color:#8e8e8e"
          >
            <i class="material-icons">remove</i> Project
          </router-link>

          <router-link
            to="/dashboard/Admin/training"
            class="list-group-item list-group-item-action"
            style="color:#8e8e8e"
          >
            <i class="material-icons">remove</i> Training
          </router-link>
        </ul>
      </div>

      <div>
        <div
          slot="header"
          class="list-group-item list-group-item-action"
          id="mybutton"
        >
          <i class="material-icons pr-1">person</i><b>User Management</b>
        </div>

        <ul>
          <router-link
            to="/dashboard/Admin/employeeReg"
            class="list-group-item list-group-item-action"
            style="color:#8e8e8e"
          >
            <i class="material-icons">remove</i> Employees
          </router-link>
          <router-link
            to="/dashboard/Admin/addTrainer"
            class="list-group-item list-group-item-action"
            style="color:#8e8e8e"
          >
            <i class="material-icons">remove</i> Facilitators'
          </router-link>
          <router-link
            to="/dashboard/Admin/addTrainee"
            class="list-group-item list-group-item-action"
            style="color:#8e8e8e"
          >
            <i class="material-icons">remove</i> Participants'
          </router-link>
        </ul>
      </div>

      <div>
        <div
          slot="header"
          class="list-group-item list-group-item-action"
          id="mybutton"
        >
          <i class="material-icons pr-1">settings</i><b>Settings</b>
        </div>
        <ul>
          <router-link
            to="/dashboard/Admin/role"
            class="list-group-item list-group-item-action"
          >
            <i class="material-icons">remove</i> Role
          </router-link>
        </ul>
      </div>

      <div style="margin-bottom:0px">
        <div
          slot="header"
          class="list-group-item list-group-item-action"
          id="mybutton"
        >
          <i class="material-icons pr-1">chrome_reader_mode</i><b>Reports</b>
        </div>
        <router-link
          to="/dashboard/Admin/reportsAdminAll"
          class="list-group-item list-group-item-action"
          ><i class="material-icons pr-1">remove</i>Brief Report
        </router-link>
        <router-link
          to="/dashboard/Admin/strategicReport"
          class="list-group-item list-group-item-action"
          ><i class="material-icons pr-1">remove</i>Startegic Report
        </router-link>
        <router-link
          to="/dashboard/Admin/map"
          class="list-group-item list-group-item-action"
          ><i class="material-icons pr-1">remove</i>Map
        </router-link>
        <router-link
          to="/dashboard/Admin/trainingsReport"
          class="list-group-item list-group-item-action"
          ><i class="material-icons pr-1">remove</i>Trainings Report
        </router-link>
        <router-link
          to="/dashboard/Admin/thematicAreaReport"
          class="list-group-item list-group-item-action"
          ><i class="material-icons pr-1">remove</i>Thematic Area Report
        </router-link>
        <router-link
          to="/dashboard/Admin/adminStaticsReport"
          class="list-group-item list-group-item-action"
          ><i class="material-icons pr-1">remove</i>Statistical Report
        </router-link>
        <div @click="showAlert" class="version-container">
          <span class="version">UNODC Version {{ version }}</span
          ><br />
          <span class="rights"
            >&copy;{{this.currentYear}}. All Rights Reserved</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from 'sweetalert2';

export default {
    data: () => ({
        active: true,
        basepath: localStorage.getItem("BASE_PATH"),
        version: '',
        releaseDate: '',
        htmlContent: "",
        currentYear: new Date().getFullYear()
    }),
    mounted() {

        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        const appVersion = localStorage.getItem("version")
        axios
            .post(localStorage.getItem("BASE_PATH") + "/get-version")
            .then(response => {
                if (response.data.unAuth || response.data.tokenExpired) {
                    const errorMessage = response.data.unAuth? 'You are Unauthorized. Need to Login Again': response.data.tokenExpired;
                          this.$toasted.global.errorMsg(errorMessage);
                          localStorage.clear();
                          setTimeout(() => {
                                this.$router.push("/");
                              }, 1000);
                             return; // Exit early to avoid further processing
                        }
                this.version = response.data.versionNo;
                this.releaseDate = response.data.releaseDate;
                this.htmlContent = response.data.htmlContent;
                if(appVersion != response.data.versionNo){
                  this.showAlert()
                }
                localStorage.setItem("version",response.data.versionNo)

            });
    },

    methods: {
         showAlert() {
               Swal.fire({
                 title: `TMIS Updated To Version ${this.version}`,
                 html: `<div style="margin-top: 10px; border-bottom: 1px solid #cccccc; width: 100%;"></div>
                        <div>${this.htmlContent}</div>`,
                 icon: 'success',
                 showCloseButton: false,
                 showConfirmButton: true,
                 confirmButtonText: 'Close',
                 confirmButtonColor: '#00a6e4',
                 width: '50em',
                willOpen: () => {
                // Set inline styles on the popup
                 const swalPopup = document.querySelector('.swal2-popup');
                     if (swalPopup) {
                           swalPopup.style.height = '700px';       // Set fixed height
                           swalPopup.style.overflowY = 'auto';     // Enable vertical scrolling
                         }

                // Set inline styles on the backdrop
                  const swalBackdrop = document.querySelector('.swal2-container');
                    if (swalBackdrop) {
                        swalBackdrop.style.background = 'rgba(0, 0, 0, 0.7)'; // Custom backdrop color
                     }

                  const swalIcon = document.querySelector('.swal2-icon');
                     if (swalIcon) {
                         swalIcon.style.margin = '0.4em auto 0.5em';
                      }
                   }
                });
            }

    }
};
</script>

<style>
.vs-collapse {
    padding: 0px !important;
}

.vs-collapse-item--header {
    padding: 0px !important;
}
</style>
<style scoped>
body {
    overflow-x: hidden;
}

.material-icons {
    font-size: 20px !important;
    vertical-align: bottom;
}

#sidebar-wrapper {
    min-height: 100vh;
    margin-left: -15rem;
    -webkit-transition: margin 0.25s ease-out;
    -moz-transition: margin 0.25s ease-out;
    -o-transition: margin 0.25s ease-out;
    transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
    padding: 0.875rem 1.25rem;
    font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
    width: 15rem;
}

#page-content-wrapper {
    min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
    margin-left: 0;
}

.version-container {
  width: 235px;
  margin-top: 20px;
  cursor: pointer;
  padding: 1px;
  text-align: center;
  max-width: 300px;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.version {
  font-weight: bold;
  font-size: 1em;
  color: #333;
}

.rights {
  font-size: 0.9em;
  color: #777;
}

.box-check-v{
  text-align: center;
}
/* Custom styles for SweetAlert2 */
/*
.swal-custom-html-container {
  border-top: 1px solid #bfbaba !important;
  height: 500px !important;
  overflow-y: auto !important;
}
*/
/*
.swal2-popup.custom-swal-height {
  height: 500px !important;
  overflow-y: auto !important;
}*/



@media (min-width: 768px) {
    #sidebar-wrapper {
        margin-left: 0;
    }

    #page-content-wrapper {
        min-width: 0;
        width: 100%;
    }

    #wrapper.toggled #sidebar-wrapper {
        margin-left: -15rem;
    }
}

::-webkit-scrollbar {
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;

}

/* Handle */
::-webkit-scrollbar-thumb {
    background: rgba(7, 167, 225);
    border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: rgba(7, 167, 225);
}

/* scrollbar css ends */
@media print {
    #sidebar-wrapper {
        display: none;
    }
}
</style>
